import 'tiny-slider/src/tiny-slider.scss';
import './styles/style.scss';

import Slider from './Slider';
import SliderPagination from './SliderPagination';

export default Slider;
export { SliderPagination };



// WEBPACK FOOTER //
// ./src/components/Slider/index.js